import { render, staticRenderFns } from "./arrow-down.vue?vue&type=template&id=5654fbe8"
import script from "./arrow-down.vue?vue&type=script&lang=js"
export * from "./arrow-down.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports